import {gsap} from 'gsap';
import section1 from './section-1';

const sequence = promokit.sequence({
  el: '#tit-sequence',
  path: 'https://wstatic-cdn.plaync.com/promo/lineage2m/update/2020/200805_update/img/sequence/',
  prefix: 'title_',
  frame: 60,
  loop: true,
  preload: true,
  fps: 15
});

const bgVideo = promokit.video({
  el: '.section-1__bg-player',
  url: 'https://vod.plaync.com/Lineage2M/l2m_0805update_teasing.mp4',
  loop: true
});

const _animation = function () {
  return gsap.timeline({paused: true})
      .addLabel('start')
      .from('.p-tit__sequence', {opacity: 0, duration: 1.5, ease: 'Power1.easeIn'}, 'start+=.5')
      .from('.p-sub-tit', {opacity: 0, duration: 1.5, ease: 'Power1.easeIn'}, 'start+=.5')
      .from('.section-1__bg-1', {opacity: 0, scale: 1.3, duration: 1.8, ease: 'Power3.easeInOut'}, 'start+=1.2')
      .from('.section-1__bg-2', {opacity: 0, scale: 1.4, duration: 1.8, ease: 'Power4.easeInOut'}, 'start+=1.3')
      .from('.section-1__bg-player', {opacity: 0, duration: 1, ease: 'Power4.easeIn'}, 'start+=2')
      .add(() => {bgVideo.play();})
      .from('.p-logo', {opacity: 0, duration: 0.6, ease: 'Power2.easeIn'}, 'start+=2')
      .from('.p-chronicle', {opacity: 0, duration: 0.6, ease: 'Power2.easeIn'}, 'start+=2')
      .from('.p-cont--1', {opacity: 0, duration: 0.6, ease: 'Power2.easeIn'}, 'start+=2')
      .from('.p-cont--2', {opacity: 0, duration: 0.6, ease: 'Power2.easeIn'}, 'start+=2')
      .from('.p-cont--3', {opacity: 0, duration: 0.6, ease: 'Power2.easeIn'}, 'start+=2');
};

promokit.page({
  type: 'basic',

  game: 'lineage2m',

  cnb: true,

  headerButton: {
    el: '.header-button',
    cookie: {
      type: 'day',
      key: 'INDEX_WEB_VISIT_200805_update',
      value: false
    },
    home: true,
    event: false,
    sns: true,
    theme: 'white'
  },

  footer: {
    fixed: true,
    theme: 'white'
  },

  components: [
    section1
  ]
});

promokit.preload({
  complete: function() {
    if(!(navigator.userAgent.toLowerCase().indexOf('firefox') > -1))
      _animation().play();
    else
      bgVideo.play();

    sequence.play();
  }
});



// WEBPACK FOOTER //
// ./src/js/index.js